import { useMemo } from "react";

import { type MessageType } from "shared/types";
import { type Conversation } from "shared/apiClient";

import { useMessages } from "@/hooks";

export type UseMessageTypeExistsOptions = {
  messageType: MessageType;
  messages?: Conversation["messages"];
};

export function useMessageTypeExists(options?: UseMessageTypeExistsOptions) {
  const { messageType, messages: messagesOverride } = options || {};

  const { messages } = useMessages();

  return useMemo(() => {
    const actualMessages = messagesOverride ? messagesOverride : messages;

    return actualMessages?.some((message) => {
      return message.message_type === messageType;
    });
  }, [messageType, messages, messagesOverride]);
}
